import Text from '@components/Text';
import colors from '@constants/colors';
import { IconProps } from '@models/icons';
import { JSX, ReactNode } from 'react';

import styles from './styles.module.scss';

interface Props {
    icon: (props: IconProps) => JSX.Element;
    children?: ReactNode;
    selected?: boolean;
    onClick?: ()=>void;
}

function MenuShortcut({
  icon: Icon, children, selected, onClick,
}:Props) {
  const color = selected ? colors.gray7 : colors.gray5;
  return (
        <button className={styles.menu}
                onClick={onClick} >
            <Icon color={color}/>
            <Text fontWeight='bold' color={color}>
                {children}
            </Text>
        </button>
  );
}

export default MenuShortcut;
